// extracted by mini-css-extract-plugin
export default {"section":"Refresh_section__o8pg8","button":"Refresh_button__XaGg-"};